import React, { useEffect, useState } from 'react';
import { PagesCardList } from 'components/organisms';
import { generateEditorPath, generatePortalImg } from 'services/generators'
import { formatDistanceToNow, isValid } from 'date-fns'
import { pt } from 'date-fns/locale'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { isPathAbsolute } from 'services/helpers'

const computeLastModified = (lastModified) => {
  if (!lastModified) return 'Sem informação'
  const lastModifiedDate = new Date(lastModified)
  const isValidDate = isValid(lastModifiedDate)
  if (!isValidDate) return 'Sem informação'
  const computedDateDistance = formatDistanceToNow(
    lastModifiedDate,
    { locale: pt }
  )
  return `Editado há ${computedDateDistance}`
}

const PagesUserList = ({ subweb }) => {
  const [data, setData] = useState([])
  const {
    isLoading, pagesQuickAccess
  } = useSelector(
    (state) => state.subweb
  )

  useEffect(() => {
    if (pagesQuickAccess.length > 0) {
      const pagesData = pagesQuickAccess.map((page) => {
        const { id: pageId, title, updatedAt: lastModified } = page
        const { image } = page.seo
        const lastModifiedDistance = computeLastModified(lastModified)

        // handle image
        let img = null
        if (image) {
          img = isPathAbsolute(image)
            ? generatePortalImg({ src: image, height: 134, isLocal: false })
            : generatePortalImg({ src: image, height: 134, isLocal: true })
        }

        return {
          title: title ? title.pt || title : null,
          img,
          description: lastModifiedDistance,
          to: generateEditorPath({ pageId, subweb }),
          key: pageId,
          lastModified,
        }
      })
      setData(pagesData)
    } else setData([])
    return () => {
      // cleanup function that cancels pending requests
      setData([])
    }
  }, [pagesQuickAccess, subweb])

  return <PagesCardList pages={data} loading={isLoading} />
};

PagesUserList.propTypes = {
  subweb: PropTypes.string,
}

PagesUserList.defaultProps = {
  subweb: null,
}

export default PagesUserList;
